import { FC, useEffect, useRef } from "react";
import { useUserPreferences } from "src/hooks/useUserPreferences";
import { useAppActions } from "src/hooks/stores/use-app-store";

const UserPreferences: FC = () => {
  const { data, loading } = useUserPreferences();
  const { setUserPreferences } = useAppActions();
  const isUserPreferencesSetRef = useRef(false);

  useEffect(() => {
    if (!data || loading || isUserPreferencesSetRef.current) {
      return;
    }
    setUserPreferences(data?.userPreferences || data?.userPreferencesByEmail);
    isUserPreferencesSetRef.current = true;
  }, [setUserPreferences, data, loading]);

  return <></>;
};

export default UserPreferences;
